// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fISE","col":"styles_col__3_zVp","actions":"styles_actions__3zn0F","conflict":"styles_conflict__1OeP2"};